export const MY_OFFERINGS_TEXTS = {
  // Empty state
  EMPTY_STATE: {
    HEADING: 'No offerings assigned',
    TEXT: "Add your first offering now, or check with your offering's owner to see if it's already available in Panorama",
  },
};
